import { Container, Text, Spacer } from 'roadie-ui'
import { ExternalLink } from 'components/layout/links'
import { LocalizedText } from 'localization'

type SupportFooterProps = {
  helpText: string
}

const SupportFooter: React.FC<SupportFooterProps> = ({ helpText }) => {
  return (
    <Container.Base $textAlign="center">
      <Text.Button $color="neutral-black">{helpText}</Text.Button>
      <Spacer $height="0.7rem" />
      <ExternalLink href={`${import.meta.env.REACT_APP_SUPPORT_URL}/support/s/contactsupport`}>
        <Text.Body2 $fontWeight="600">
          <LocalizedText translationKey="dweb_block_payments_support_footer_contact_support" />
        </Text.Body2>
      </ExternalLink>
    </Container.Base>
  )
}

export default SupportFooter
